import type { FC } from "react";

import type { IPlainTooltipProps } from "@similarweb/ui-components";
import { PlainTooltip } from "@similarweb/ui-components";

import { is } from "app/pages/sales-intelligence/utils/type-guards";

import { StyledCountValue, StyledListCaption, StyledNewResultBlock } from "./styles";

type NewWebsitesButtonProps = {
    count: number;
    title: string;
    tooltipContent?: IPlainTooltipProps["tooltipContent"];
    onClick: () => void;
};

const NewWebsitesButton: FC<NewWebsitesButtonProps> = ({ count, title, tooltipContent, onClick }) => {
    return (
        <PlainTooltip
            enabled={is.undefined(tooltipContent)}
            key="button-item"
            tooltipContent={tooltipContent}
        >
            <StyledNewResultBlock onClick={onClick}>
                <StyledCountValue>{count}</StyledCountValue>
                <StyledListCaption>{title}</StyledListCaption>
            </StyledNewResultBlock>
        </PlainTooltip>
    );
};

export default NewWebsitesButton;
